interface Agent {
  id: number
  name: string
  email: string
  avatar_url: string | null
  role: string
}

interface EmailConfigPanelProps {
  agents: Agent[]
  sentByAgentId: number
  onAgentChange: (id: number) => void
  emailFromName: string
  onFromNameChange: (value: string) => void
  emailReplyTo: string
  onReplyToChange: (value: string) => void
  name: string
  onNameChange: (value: string) => void
  nameError?: string
}

export default function EmailConfigPanel({
  agents,
  sentByAgentId,
  onAgentChange,
  emailFromName,
  onFromNameChange,
  emailReplyTo,
  onReplyToChange,
  name,
  onNameChange,
  nameError,
}: EmailConfigPanelProps) {
  return (
    <div className="w-[280px] flex-shrink-0 border-r border-gray-200 bg-white overflow-y-auto p-4 space-y-5">
      {/* Agent selector */}
      <div>
        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
          De
        </label>
        <select
          value={sentByAgentId}
          onChange={(e) => onAgentChange(parseInt(e.target.value))}
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
        >
          {agents.map((agent) => (
            <option key={agent.id} value={agent.id}>
              {agent.name}
            </option>
          ))}
        </select>
      </div>

      {/* From Name */}
      <div>
        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
          Nome do Remetente
        </label>
        <input
          type="text"
          value={emailFromName}
          onChange={(e) => onFromNameChange(e.target.value)}
          placeholder="ex: Equipe de Suporte"
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
        />
        <p className="mt-1 text-xs text-gray-500">
          Deixe em branco para usar o nome da organização
        </p>
      </div>

      {/* Reply To */}
      <div>
        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
          Responder para
        </label>
        <input
          type="email"
          value={emailReplyTo}
          onChange={(e) => onReplyToChange(e.target.value)}
          placeholder="suporte@empresa.com"
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
        />
        <p className="mt-1 text-xs text-gray-500">
          Endereço para onde as respostas serão enviadas
        </p>
      </div>

      {/* Internal Name */}
      <div>
        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
          Nome Interno <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="ex: Campanha de boas-vindas"
          className={`w-full px-3 py-2 text-sm border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none ${
            nameError ? 'border-red-300 bg-red-50' : 'border-gray-300'
          }`}
        />
        {nameError && (
          <p className="mt-1 text-xs text-red-600">{nameError}</p>
        )}
      </div>
    </div>
  )
}
